export enum RosaCoreLocalStorageKey {
    REFRESH_TOKEN = 'REFRESH_TOKEN',
    CONNECTED_WITH_SSO = 'CONNECTED_WITH_SSO',
    CONNECTED_AS_PROJECT_ID = 'CONNECTED_AS_PROJECT_ID',
    CONNECTED_AS_EMAIL = 'CONNECTED_AS_EMAIL',
    PROJECT_ID = 'PROJECT_ID',
    DEVELOPER_HELPER = 'DEVELOPER_HELPER',
    SESSION_ID = 'SESSION_ID'
}
